<div class="ion-activatable">
  <bepatient-dynamic-menu-main-icon [color]="color" [icon]="icon">
  </bepatient-dynamic-menu-main-icon>
  <span>{{ label }}</span>
  <svg
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L9 8.5L1 16"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <ion-ripple-effect></ion-ripple-effect>
</div>
